/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 */

/**
 * ThemeVariablesRoot
 *
 * @file ThemeVariablesRoot.jsx
 * @author Anuja Gaikwad
 * @description Lightweight wrapper that applies a root class which exposes
 *              CSS variables. Only the light theme variables are set; dark
 *              theme relies on existing fallbacks in component styles.
 */

import React from 'react';
import PropTypes from 'prop-types';
import useThemeVariablesRootStyles from './ThemeVariablesRootStyles';

const ThemeVariablesRoot = ({ theme, className, children, ...rest }) => {
  const classes = useThemeVariablesRootStyles();
  const themeClass = theme ? `theme-${theme}` : '';

  return (
    <div className={`${classes.themedRoot} ${themeClass} ${className || ''}`} {...rest}>
      {children}
    </div>
  );
};

ThemeVariablesRoot.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  children: PropTypes.node
};

ThemeVariablesRoot.defaultProps = {
  theme: undefined,
  className: '',
  children: null
};

export default ThemeVariablesRoot;
